export function makeInitials(signatureText: string) {
  return signatureText
    .toUpperCase()
    .trim()
    .split(/[\s-]+/)
    .reduce((acc: string, curr: string) => {
      return curr[0] !== undefined ? acc + curr[0] : acc;
    }, '');
}
